import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { isUndefined } from 'lodash-es';

import { Feature, HeatingBurnersNErrorStatusProperties } from '@vi-iot/client';
import { PillType } from '../../../shared/components/pill/pill.model';

@Component({
  selector: 'app-lecture-code-address-panel',
  templateUrl: './lecture-code-address-panel.component.html',
  styleUrls: ['./lecture-code-address-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LectureCodeAddressPanelComponent implements OnInit {
  readonly pillType = PillType;
  @Input() feature: Feature<HeatingBurnersNErrorStatusProperties, never>;
  code: number;

  ngOnInit(): void {
    this.getCode();
  }

  getCode(): void {
    this.code = !!this.feature?.properties?.errorCode
      ? this.feature.properties.errorCode.value
      : null;
  }

  get isCode(): boolean {
    return !isUndefined(this.feature?.properties?.errorCode?.value);
  }

  getDescription(): string {
    const lectureCodes = [
      {
        value: 0,
        message: '+INSTALLATIONS.INSTALLATION.LECTURE_CODE_ADDRESS.DESCRIPTION_0',
      },
      {
        value: 2,
        message: '+INSTALLATIONS.INSTALLATION.LECTURE_CODE_ADDRESS.DESCRIPTION_2',
      },
      {
        value: 3,
        message: '+INSTALLATIONS.INSTALLATION.LECTURE_CODE_ADDRESS.DESCRIPTION_3',
      },
      {
        value: 6,
        message: '+INSTALLATIONS.INSTALLATION.LECTURE_CODE_ADDRESS.DESCRIPTION_6',
      },
      {
        value: 8,
        message: '+INSTALLATIONS.INSTALLATION.LECTURE_CODE_ADDRESS.DESCRIPTION_8',
      },
      {
        value: 9,
        message: '+INSTALLATIONS.INSTALLATION.LECTURE_CODE_ADDRESS.DESCRIPTION_9',
      },
      {
        value: 29,
        message: '+INSTALLATIONS.INSTALLATION.LECTURE_CODE_ADDRESS.DESCRIPTION_29',
      },
      {
        value: 33,
        message: '+INSTALLATIONS.INSTALLATION.LECTURE_CODE_ADDRESS.DESCRIPTION_33',
      },
      {
        value: 61,
        message: '+INSTALLATIONS.INSTALLATION.LECTURE_CODE_ADDRESS.DESCRIPTION_61',
      },
      {
        value: 62,
        message: '+INSTALLATIONS.INSTALLATION.LECTURE_CODE_ADDRESS.DESCRIPTION_62',
      },
      {
        value: 68,
        message: '+INSTALLATIONS.INSTALLATION.LECTURE_CODE_ADDRESS.DESCRIPTION_68',
      },
      {
        value: 85,
        message: '+INSTALLATIONS.INSTALLATION.LECTURE_CODE_ADDRESS.DESCRIPTION_85',
      },
    ];

    const matchedLectureCode = lectureCodes.filter((lc) => lc.value === this.code);

    if (matchedLectureCode[0] && this.code === matchedLectureCode[0].value) {
      return matchedLectureCode[0].message;
    } else {
      return this.code >= 1 && this.code <= 127
        ? '+INSTALLATIONS.INSTALLATION.LECTURE_CODE_ADDRESS.DESCRIPTION_INTERNAL_MESSAGE'
        : '+INSTALLATIONS.INSTALLATION.LECTURE_CODE_ADDRESS.DESCRIPTION_ERROR';
    }
  }
}
